<ul class="d-list">
  <ng-content></ng-content>
</ul>
